// 整体效果
import React, { Component } from 'react';
import { Row, Col, Radio } from 'antd';
import { GraphWrapper } from '@/components/Graph';
import { overallEffectLine } from '../GraphConfig';
import DownloadDialog from '../Download';
import './index.less';
const indexMap = {
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六',
};
export default class OverallEffect extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentIntro: '',
            currentIntroName: '',
            indexInfos: [],
            currentComparisonGroup: [],
        };
    }
    componentDidMount() {
        this.initDataIntro();
    }
    initCharts() {
        const { overAllInfos } = this.props.dataEffectValue.keyIndexs;
        const { currentIntro } = this.state;
        if (!currentIntro)
            return;
        this.setState({
            currentComparisonGroup: overAllInfos[currentIntro] || {},
        });
    }
    initDataIntro() {
        const { indexInfos, overAllInfos } = this.props.dataEffectValue.keyIndexs;
        const arr = indexInfos;
        for (let i = 0; i < arr.length; i++) {
            arr[i]['indexName'] = `指标${indexMap[i + 1]}`;
        }
        this.setState({
            indexInfos: arr,
            currentIntro: indexInfos[0] ? indexInfos[0].type : '',
            currentIntroName: indexInfos[0] ? overAllInfos.type[indexInfos[0].type] : '',
        }, () => {
            this.initCharts();
        });
    }
    onIntroChange(e) {
        const { overAllInfos } = this.props.dataEffectValue.keyIndexs;
        this.setState({
            currentIntro: e.target.value,
            currentIntroName: overAllInfos.type[e.target.value],
        }, () => {
            this.initCharts();
        });
    }
    render() {
        const { sceneCode } = this.props.dataEffectValue;
        const { currentComparisonGroup, indexInfos, currentIntro, currentIntroName } = this.state;
        return (<div className="overall-effect">
        <div className="data-effect-title mb_20">整体情况</div>
        
        <div className="border mt_20">
          <div className="data-effect-title mb_20" style={{ fontSize: '14px' }}>{currentIntroName}</div>
          <DownloadDialog className="download-btn" type="overAllData" sceneCode={sceneCode}/>
          <div className="overall-effect-graph">
            <GraphWrapper className="overall-effect-graph-wrapper" config={overallEffectLine(currentComparisonGroup, currentComparisonGroup.isRate)} height={350}/>
          </div>
          <div className="overall-effect-introduce">
            <p>数据解读/指标说明</p>
            <Radio.Group className="data-effect-radio-group" onChange={this.onIntroChange.bind(this)} value={currentIntro}>
              {indexInfos && indexInfos.map((item, index) => {
            return <Row className="data-effect-introduce-item" key={index}>
                  <Col span={1}>
                    <Radio value={item.type}/>
                  </Col>
                  <Col span={23}>
                    <div className="overall-effect-introduce-wrapper mb_10">
                      <div className="w80">{item.indexName}：</div>
                      <div>{item.quotaName}</div>
                    </div>
                    <Row>
                      <Col span={10} className="overall-effect-introduce-wrapper"><div className="w80">目标模块：</div><span className="fc_8D8E99">{item.targetModelName}</span></Col>
                      <Col span={14} className="overall-effect-introduce-wrapper">对比模块：<span className="fc_8D8E99">{item.compareModel}</span></Col>
                    </Row>
                    {item.dataExplain && <div className="overall-effect-introduce-wrapper">
                      <div className="w80">数据解读：</div>
                      <span className="fc_8D8E99">{item.dataExplain}</span>
                    </div>}
                  </Col>
                </Row>;
        })}
            </Radio.Group>
          </div>
        </div>
      </div>);
    }
}
